<template>
<div class="component" v-if="show">
    <span class="message">Application has been updated. Please refresh to update.</span>

    <button type="button" @click="reload">Reload</button>
</div>
</template>

<script>
export default {
    name: "out-of-date-message",

    props: {
        show: {
            default: false,
            type: Boolean
        }
    },

    methods: {
        reload () {
            window.location.reload(true)
        }
    }
}
</script>

<style scoped>
.component {
    background: #ffffff;
    border: 1px solid #b7b7b7;
    bottom: 50px;
    box-shadow: 0px 0px 10px #d9d9d9;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 250px;
    padding: 15px;
    position: fixed;
    right: 50px;
    text-align: center;
    z-index: 100;
}

.message {
    margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/OutOfDateMessage.vue